import { inject } from '@angular/core';
import { Router, ActivatedRouteSnapshot } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { FBaseService, collection } from '../services/firebase/f-base.service';
import { StorageItems } from '../constants/storage-items.constants';
import { AuthService } from '../services/auth.service';

export const groupOwnerGuard = async (route: ActivatedRouteSnapshot) => {
  const fbService = inject(FBaseService);
  const router = inject(Router);
  const authService = inject(AuthService)

  try {
    let groupId = route.params['groupId'];

    if (!groupId) {
      let currentRoute = route;
      while (currentRoute.parent && !groupId) {
        currentRoute = currentRoute.parent;
        groupId = currentRoute.params['groupId'];
      }
    }

    if (!groupId || groupId === 'all') {
      return true;
    }

    const userId = authService.user?.uid!;
    const isUserAdmin = localStorage.getItem(StorageItems.USER_ID_FOR_ADMIN);

    if (isUserAdmin) {
      return true;
    }

    const group = await firstValueFrom(fbService.getById(collection.groups, groupId));
    if (!group) {
      router.navigateByUrl('/select-subject');
      return false;
    }

    if (group.metadata?.createdBy?.id === userId) {
      return true;
    }

    const subject = await firstValueFrom(fbService.getById(collection.subjects, group.subjectId));
    if (subject && subject.metadata?.createdBy?.id === userId) {
      return true;
    }

    router.navigateByUrl('/select-subject');
    return false;

  } catch (error) {
    console.error('Group owner guard error:', error);
    return false;
  }
};